import WallClockTimeTracker from '@app/application/wall-clock-time/services/wall-clock-time-tracker'
import { SfLog } from '@app/adapters/logger'

export default (doc: Document): WallClockTimeTracker | null => {
  const element = doc.querySelector(
    "[data-behaviour='wall-clock-time-tracker']"
  ) as HTMLElement

  if (element) {
    const { ledgerId, ownerId, ownerType, companyId, firmId } =
      element.dataset ?? {}

    if (!ledgerId || !ownerId || !ownerType || !companyId || !firmId) {
      SfLog.error(
        'WallClockTimeTracker requires ledgerId, ownerId, ownerType, companyId, and firmId'
      )
      return null
    }

    const tracker = new WallClockTimeTracker(
      parseInt(ownerId),
      ownerType,
      parseInt(ledgerId),
      companyId,
      firmId
    )
    tracker.start()

    return tracker
  }

  return null
}
